import PulseMark from '../PulseMark';

// Shared brand lockup for the 4 portal auth screens (CustomerSignIn, ForgotPassword,
// SetPasswordScreen) — matches AuthGate.js's internal sign-in treatment so the first thing a
// customer sees looks like the same product a PM sees.
export default function PortalBrand() {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 18, marginBottom: 16 }}>
      <PulseMark size={72} trim />
      <span style={{ fontFamily: 'Georgia', fontSize: 56, fontWeight: 'bold', color: 'var(--heading)' }}>
        Pulse
      </span>
    </div>
  );
}
